/**
 * The ingredient catalog is owned by git (recipe-builder) since 2026-10-05: its Recipe sync writes
 * `globals/master_ingredients` from `data/master_ingredients.json`, with the matcher's vectors, and would overwrite any
 * CRM edit on its next run (#1188). Firestore rules refuse admin writes to the document; this guard stops each CRM
 * write path first, with a message saying where to make the change instead.
 *
 * Guarded: saving, deleting and JSON-importing ingredients (ingredientsController.js) and merging duplicates
 * (duplicatesResolver.js). Viewing, searching and exporting stay.
 */

export const CATALOG_READ_ONLY_MESSAGE =
  "🔒 The ingredient catalog is managed in recipe-builder. Change ingredients there (scripts/register_ingredient.py): the next sync would overwrite a CRM edit.";

/** Shows why the catalog can't be written here, and returns true so a caller can `if (refuseCatalogWrite(...)) return;`. */
export function refuseCatalogWrite(showToast) {
  if (typeof showToast === "function") showToast(CATALOG_READ_ONLY_MESSAGE, "danger");
  return true;
}
